import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from '../../redux/connect';
import {
  selectPushpinAction,
  deselectPushpinsAction,
  changeLocationAction,
  trackEvent as trackEventAction,
} from '../../redux/actions';
import {
  getCurrentPreviewIssueId,
  getCurrentPreviewIssueAttributes,
  getCurrentSheets,
  getIssuesCollectionLoading,
} from '../../redux/selectors';
import { SvgIcon, IconButton } from '@adsk/bim360-matrix-react-components';
import IssuePreview from '../../components/IssuePreview';
import IssueAttachmentGallery from '../../components/IssueAttachmentGallery';
import { screenType } from '../../constants/analytics';
import { viewRfiClose } from '../../utils/analytics-helpers';
import { issueAttributesType, sheetObjectType } from '../../constants/proptype-validation';
import arrowBack from '../../assets/images/icons/icon-arrow-back.svg';

export class PureIssuePreviewPanel extends PureComponent {

  constructor(props) {
    super(props);
   
    this.panelOpenTime = Date.now();
  }

  componentDidMount() {
    const { issue, selectPushpinAction, isLoadingCollection } = this.props;
    // Don't select pushpin if we're still loading/fetching issues - The pushpin extension deselect pushpins on any pushpin creation.
    if (issue.pushpinAttributes && !isLoadingCollection) {
      selectPushpinAction(issue);
    }

    this.goToIssuesList = this.goToIssuesList.bind(this);
  }

  componentDidUpdate(prevProps) {
    // Select the pushpin if one of the following is true -
    // 1. We didn't have the issue data before and have it now
    // 2. The current sheet has changed
    // 3. The fetching of all issues has just completed
    // In any case, we check that the fetching of all issues has been completed, we shouldn't select a pushpin before that
    if (!this.props.isLoadingCollection && (!prevProps.issue.pushpinAttributes && this.props.issue.pushpinAttributes
      || prevProps.currentSheets !== this.props.currentSheets
      || prevProps.isLoadingCollection)) {
      this.props.selectPushpinAction(this.props.issue);
    }
  }

  componentWillUnmount() {
    this.props.deselectPushpinsAction();
  }

  goToIssuesList() {
    const { changeLocationAction, returnToRFIsList, issue, trackEvent } = this.props;
    returnToRFIsList && returnToRFIsList();
    const timeToClosePanel = Math.round((Date.now() - this.panelOpenTime) / 1000);
    trackEvent(viewRfiClose(issue.id, issue.status, timeToClosePanel));
    changeLocationAction('/rfis');
  }

  render() {
    return (
      <div className="IssuePreviewPanel">
        <IssuePreview
          origin={screenType.PANEL}
          container={this}
          closeIssuePreview={this.goToIssuesList}
        />
        <IconButton
          className="IssuePreviewPanel__back-link"
          onClick={this.goToIssuesList}
          styleType={IconButton.StyleType.MINIMAL}
        >
          <SvgIcon width="11px" height="17px">
            {arrowBack}
          </SvgIcon>
        </IconButton>

        <IssueAttachmentGallery container={this} />
      </div>
    );
  }
}

PureIssuePreviewPanel.displayName = 'IssuePreviewPanel';

PureIssuePreviewPanel.propTypes = {
  issueId: PropTypes.string.isRequired,
  issue: issueAttributesType.isRequired,
  selectPushpinAction: PropTypes.func.isRequired,
  deselectPushpinsAction: PropTypes.func.isRequired,
  changeLocationAction: PropTypes.func.isRequired,
  currentSheets: PropTypes.arrayOf(sheetObjectType),
  isLoadingCollection: PropTypes.bool.isRequired,
  returnToRFIsList: PropTypes.func,
};
const mapStateToProps = state => ({
  issueId: getCurrentPreviewIssueId(state),
  issue: getCurrentPreviewIssueAttributes(state),
  currentSheets: getCurrentSheets(state),
  isLoadingCollection: getIssuesCollectionLoading(state),
});


export default connect(mapStateToProps, {
  selectPushpinAction,
  deselectPushpinsAction,
  changeLocationAction,
  trackEvent: trackEventAction,
})(PureIssuePreviewPanel);
